import React from 'react'
import { FcLike, FcLikePlaceholder, FcUndo } 
from 'react-icons/fc';
import { toast } from 'react-toastify';
import { useState } from 'react';
export const Card = (prosp) => {
    const[more ,setmore]=useState(false);
    const[like,setlike]=useState(false);
    const details=prosp.details;
    const description=more?(details.description):( details.description.substring(0,100))
    function moreHandler(){
        setmore(!more);
    }
    function likeHandler(){
        setlike(!like);
        like?(
            toast.error(`You dislike ${details.title}`)):
           
            (
                
                toast.success(`You like ${details.title}`))
        
    }
  return (
    <div className='w-[310px] rounded-lg bg-bgDark overflow-hidden transition-all duration-200'>
       <div className='w-full relative'>
        <img  src={details.image.url}></img>
        <div className='w-10 h-10 bg-white flex justify-center items-center text-3xl rounded-[50%] absolute right-2 -bottom-4' onClick={likeHandler}>
            {
                like ? (
                    <FcLike></FcLike>
                ):
                (
                    <FcLikePlaceholder/>
                )
            }
                 
        </div>
       
       </div>
       <div className='text-white px-6 py-2 flex flex-col gap-2' >
        <h1 className='text-xl font-semibold'>{details.title}</h1>
        <p>{description}
        <span className='text-sm text-blue-700'>
            {
                more ? (
                    <button  onClick={moreHandler} type="">Show Less</button>
                ):(
                    <button onClick={moreHandler} type="">...Show more</button>
                )
            }
        </span>

        </p>
       
       </div>
       
    </div>
  )
}
